import { ScrollTrigger } from 'gsap/ScrollTrigger';

/**
 * Centralised, rAF-coalesced ScrollTrigger refresh.
 * Pinned sections use refreshPriority so they are measured before downstream triggers.
 */
let frame = 0;

export function scheduleRefresh() {
  if (frame) return;
  frame = window.requestAnimationFrame(() => {
    frame = 0;
    ScrollTrigger.sort();
    ScrollTrigger.refresh();
  });
}

/** Refresh once fonts and still-loading images have settled. Returns cleanup. */
export function watchLayoutDependencies(scope: Document | HTMLElement = document) {
  let alive = true;
  document.fonts?.ready.then(() => { if (alive) scheduleRefresh(); }).catch(() => {});
  const imgs = Array.from(scope.querySelectorAll('img')).filter((i) => !i.complete);
  const onImg = () => { if (alive) scheduleRefresh(); };
  imgs.forEach((i) => {
    i.addEventListener('load', onImg, { once: true });
    i.addEventListener('error', onImg, { once: true });
  });
  window.addEventListener('load', onImg);
  return () => {
    alive = false;
    imgs.forEach((i) => {
      i.removeEventListener('load', onImg);
      i.removeEventListener('error', onImg);
    });
    window.removeEventListener('load', onImg);
  };
}